import { render, staticRenderFns } from "./sfc-hello-bar-v3.vue?vue&type=template&id=baee1782&scoped=true&lang=pug&"
import script from "./sfc-hello-bar-v3.vue?vue&type=script&lang=js&"
export * from "./sfc-hello-bar-v3.vue?vue&type=script&lang=js&"
import style0 from "./sfc-hello-bar-v3.vue?vue&type=style&index=0&id=baee1782&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baee1782",
  null
  
)

export default component.exports